import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import NotificationUtility from "Core/NotificationUtility";
import LoaderUtility from "Core/LoaderUtility";

export interface Props extends RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
}

class NavigationEventMonitorWithRouter extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            NotificationUtility.CloseNonPersistentNotifications();
            LoaderUtility.reset()
        }
    }

    render() {
        return (
            <div>{this.props.children}</div>
        )
    }
}

const NavigationEventMonitor = withRouter(NavigationEventMonitorWithRouter);

export default NavigationEventMonitor;


